<template>
  <div class="card-box mb-3">
    <div class="card-box__image">
      <img :src="imageSrc" alt="Card image" />
    </div>
    <div class="card-box__content">
      <div class="card-box__title">{{ title }}</div>
      <div class="card-box__subtitle">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">


defineProps<{
  imageSrc: string;
  title: string;
  subtitle: string;
}>();
</script>

<style scoped>
.card-box {
  display: flex;
  align-items: center;
  border: 1px solid #d3d3d3;
  border-radius: 10px;
  padding: 16px;
  background: #fff;
  max-width: 400px;
}
.card-box__image {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}
.card-box__image img {
  width: 86px;
  height: 50px;
  object-fit: contain;
}
.card-box__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  height: 100px;
}
.card-box__title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  line-height: 24px;
  font-family: "Inter", sans-serif;
  font-style: semi-bold;
}
.card-box__subtitle {
  font-size: 14px;
  color: #595a5a;
  line-height: 21px;
  font-family: "Inter", sans-serif;
  font-style: medium;
  font-weight: 500;
}
</style>
